import { NgModule, isDevMode, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgxEchartsModule } from 'ngx-echarts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import {
  TranslateModule,
  TranslateLoader,
  TranslateService
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslatedPaginatorIntl } from './core/services/translated-paginator-intl.service';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { AfterLoginComponent } from './layout/after-login/after-login.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SetInterceptorService } from './core/interceptor/set-interceptor.service';
import { GetInterceptorService } from './core/interceptor/get-interceptor.service';
import { AfterLoginSharedModule } from './shared/after-login.shared.module';
import { ToastrModule } from 'ngx-toastr';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { InitialService } from './core/services/initial.service';
import { ModalsModule } from './modals/modals.module';
import { ServiceWorkerModule } from '@angular/service-worker';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initialServiceFactory(
  initialService: InitialService
): () => Promise<void> {
  return () => initialService.setUpGoogleScript();
}

@NgModule({
  declarations: [AppComponent, AfterLoginComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NgxUiLoaderModule,
    MatMenuModule,
    MatSidenavModule,
    AfterLoginSharedModule,
    ModalsModule,
    HttpClientModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    GooglePlaceModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],

  exports: [TranslateModule],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: TranslatedPaginatorIntl
    },
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: initialServiceFactory,
      deps: [InitialService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GetInterceptorService,
      multi: true
    },
    BrowserAnimationsModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
